/* eslint-disable no-nested-ternary */

import AdminSectionTitle from '../components/AdminSectionTitle';
import EventMenuOption from '../components/EventMenuOption';
import {
  IconCard1, IconMove1, IconPlay1, IconPlay2, IconSmile2,
} from '../components/icons';

interface Options {
  title: string;
  info: string;
  buttonLabel: string;
  redirectPath?: string;
  onClick?: () => void;
  hidden?: boolean;
  icon: React.ReactNode;
}

const AdminCustomersMenu: React.FC = () => {
  const options: Options[] = [
    {
      title: 'Clientes',
      info: 'En este apartado podrás visualizar la base completa de tus asistentes, con sus datos y compras asociadas. ',
      buttonLabel: 'Ver clientes',
      redirectPath: 'clients',
      icon: <IconSmile2 className='w-10 h-10 ml-2 mt-1' />,
    },
    {
      title: 'Grupos de clientes',
      info: 'En este apartado podrás organizar clientes en listas o categorías, y gestionar accesos especiales o beneficios.',
      buttonLabel: 'Ver grupos',
      redirectPath: 'groups',
      icon: <IconMove1 className='w-10 h-10 ml-2 mt-1' />,
    },
    {
      title: 'Seguimiento compras inconclusas',
      info: 'En este apartado podrás configurar y enviar comunicaciones personalizadas por mail a tu clientela.',
      buttonLabel: 'Ver seguimiento',
      redirectPath: 'customers',
      icon: <IconCard1 className='w-10 h-10 ml-2 mt-1' />,
      hidden: true,
    },
    {
      title: 'Notificaciones a clientes',
      info: 'En este apartado podrás configurar y enviar comunicaciones personalizadas por mail a tu clientela.',
      buttonLabel: 'Ver notificaciones',
      redirectPath: 'customers',
      icon: <IconPlay1 className='w-10 h-10 ml-2 mt-1' />,
      hidden: true,
    },
  ];

  return (
    <div className="my-6 flex flex-col gap-6">
      <AdminSectionTitle
        title="Productoras"
        subtitle='CRM - Gestión de clientes'
        icon={<IconPlay2 className='w-12 h-12 rotate-180' />}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 glass-surface">
        {options.map(
          (option) => !option.hidden && (
            <div key={option.title} className="mb-3">
              <EventMenuOption
                id={option.title}
                title={option.title}
                info={option.info}
                buttonLabel={option.buttonLabel}
                redirectPath={option.redirectPath}
                onClick={option.onClick}
                icon={option.icon}
              />
            </div>
          ),
        )}
      </div>
    </div>
  );
};

export default AdminCustomersMenu;
